import { cn } from '@/lib/utils';
import type { VehicleListing } from '@/models/types';
import { Button } from '../../ui/button';
import { PREVIOUS_OWNERS_OPTIONS_MAP } from './previous-owners-selector';

export const VehiclePreviousOwnersBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  className,
  buttonVariant = 'ghost',
}: {
  value: VehicleListing['previous_owners'];
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
  buttonVariant?: 'outline' | 'ghost';
}) => {
  return (
    <Button
      variant={buttonVariant}
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {
            PREVIOUS_OWNERS_OPTIONS_MAP.find(
              (option) => option.value === value.toString(),
            )?.label
          }
        </p>
      )}
    </Button>
  );
};
